import { render, staticRenderFns } from "./ContentItemTable.vue?vue&type=template&id=2ea6b597&"
import script from "./ContentItemTable.vue?vue&type=script&lang=js&"
export * from "./ContentItemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports